import { Injectable } from '@angular/core';
import { Breadcrumb } from '../../_models/breadcrumb/breadcrumb.model';
import { ThemeService } from '../theming-engine/theme.service';

@Injectable({
  providedIn: 'root'
})
export class BreadcrumbService {
  public breadcrumb: Breadcrumb = new Breadcrumb()

  constructor(private themeService: ThemeService) { }

  /** Builds a fresh trail from the route's data so the router config itself is never mutated. */
  public setBreadcrumb(routeBreadcrumb: Breadcrumb): void {
    const breadcrumb = new Breadcrumb();
    breadcrumb.routeName = this.label(routeBreadcrumb.routeName);
    breadcrumb.parents = (routeBreadcrumb.parents ?? []).map(parent => ({
      name: this.label(parent.name),
      route: parent.route
    }));
    this.breadcrumb = breadcrumb;
  }

  private label(text: string): string {
    return text
      .replace('Students', 'Learners')
      .replace('Booking', this.themeService.siteContent.placementHeaderLabel);
  }

}
